import axios from "axios";
import { IIdRecord } from "../interfaces/interfaces";
import { adapterItemResponse } from "./adapters/adapterItem";

export const deleteRecordInDb = async (_id: string) => {
  let recordId: IIdRecord = { _id: _id };
  try {
    let deleteRecord: any = await axios({
      method: "put",
      url: "/api/delete-record",
      data: recordId,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.data;
      });

    if (deleteRecord.delete === true) {
      let adaptedResponse = adapterItemResponse(deleteRecord);
      return adaptedResponse;
    }
    if (deleteRecord.delete === false) {
      return false;
    }
    return false;
  } catch (error) {
    return false;
  }
};
